import './index.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { initSentry } from './lib/sentry';

initSentry();

function ErrorFallback(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[hsl(var(--color-bg))] px-6 text-center text-[hsl(var(--color-ink))]">
      <h1 className="font-instrument text-[26px] leading-[1.15] tracking-[-0.02em]">Something went wrong.</h1>
      <p className="text-[13px] text-[hsl(var(--color-muted))]">The error has been reported. Try reloading the page.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="border border-[hsl(var(--color-hairline))] bg-[hsl(var(--color-bone))] px-4 py-2 text-[13px] font-medium text-[hsl(var(--color-ink))] transition-colors hover:border-[hsl(var(--color-hairline-hi))]"
      >
        Reload
      </button>
    </div>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
